import produce from 'immer'

const initialState = {
  propertyChecklistDismissed: false
}

const preferences = produce((draft = initialState, action) => {
  switch (action.type) {
    case 'PREFERENCES_PROPERTY_CHECKLIST_DISMISS':
      return {
        propertyChecklistDismissed: true,
      }
    default:
      return draft
  }
})

export default preferences
